// @flow
import * as React from 'react';
import moment from 'moment';
import { preFilled } from '../../OnlineWaiver';
// import CountryList from '../../UNLocationsJavascript';
import Validators, { IValidatorPackage } from '../../Validators';
import DropdownSearch from '../DropdownSearch/DropdownSearch';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import RadioGroup from '../RadioGroup/RadioGroup';
import TextField from '../TextField/TextField';
import PhoneField from '../PhoneField/PhoneField';
import * as classNames from 'classnames';
import { YearPicker, MonthPicker, DayPicker } from 'react-dropdown-date';
import { withLocalize, Translate } from "react-localize-redux";
import { toast } from 'react-toastify';
import * as API from '../../api';
import { defaultCountry } from '../../helpers';

import './AdultInformation.css';
// import { format } from 'url';
// import PropTypes from 'prop-types';


interface IAdultInformationProps {
    [Object]: Object;
    firstName: string;
    lastName: string;
    preferredName: string;
    email: string;
    phone: string;
    gender: string;
    dateOfBirth: moment;
    address: string;
    city: string;
    provinceState: string;
    country: string;
    postalZipCode: string;
    signForChildren: string;

    className: string;

    updateFirstName: (value: string) => void;
    updateLastName: (value: string) => void;
    updatePreferredName: (value: string) => void;
    updateEmail: (value: string) => void;
    updatePhone: (value: string) => void;
    updateGender: (value: string) => void;
    updateDateOfBirth: (value?: moment) => void;
    updateAddress: (value: string) => void;
    updateCity: (value: string) => void;
    updateProvinceState: (value: string) => void;
    updateCountry: (value: string) => void;
    updatePostalZipCode: (value: string) => void;
    updateSignForChildren: (value: string) => void;
    updateYearOfBirthTried: (value: boolean) => void;
    updateMonthOfBirthTried: (value: boolean) => void;
    updateDayOfBirthTried: (value: boolean) => void;

    handleClickBack: () => void;
    handleClickNext: () => void;
}

interface IAdultInformationState {
    deferErrors: boolean;
    yearOfBirth: ?number;
    monthOfBirth: ?number;
    dayOfBirth: ?number;
    countrySet: boolean;
}

// const formatDate = (date) => {	// formats a JS date to 'yyyy-mm-dd'
//     var d = new Date(date),
//         month = '' + (d.getMonth() + 1),
//         day = '' + d.getDate(),
//         year = d.getFullYear();

//     if (month.length < 2) month = '0' + month;
//     if (day.length < 2) day = '0' + day;

//     return [year, month, day].join('-');
// }

/**
 *
 * via https://stackoverflow.com/questions/1353684/detecting-an-invalid-date-date-instance-in-javascript
 *
 */
function isValidDate(d) {
    return (d instanceof Date || d instanceof moment) && !isNaN(d);
}

class AdultInformation extends React.Component<IAdultInformationProps, IAdultInformationState> {
    validators: {
        [key: string]: IValidatorPackage[];
        firstName: IValidatorPackage[];
        lastName: IValidatorPackage[];
        email: IValidatorPackage[];
        phone: IValidatorPackage[];
        gender: IValidatorPackage[];
        dateOfBirth: IValidatorPackage[];
        address: IValidatorPackage[];
        city: IValidatorPackage[];
        provinceState: IValidatorPackage[];
        country: IValidatorPackage[];
        postalZipCode: IValidatorPackage[];
        signForChildren: IValidatorPackage[];
    };

    constructor(props: IAdultInformationProps) {
        super(props);

        //var moment = require('moment');

        this.state = {
            deferErrors: true,
            // dateOfBirth: (preFilled) ? new Date(1996, 12, 31): undefined,
            yearOfBirth: (preFilled) ? 1996 : undefined,
            monthOfBirth: (preFilled) ? 12 : undefined,
            dayOfBirth: (preFilled) ? 31 : undefined,
            countrySet: false,
            countryList: {}
        };

        this.validators = {
            firstName: [{
                validator: Validators.required,
                errorMessage: <Translate id="constants_js.required"/>
            }],
            lastName: [{
                validator: Validators.required,
                errorMessage: <Translate id="constants_js.required"/>
            }],
            email: [{
                validator: Validators.email,
                errorMessage: <Translate id="constants_js.email"/>
            }],
            phone: [{
                validator: Validators.optionalPhone,
                errorMessage: <Translate id="constants_js.phone"/>
            }],
            gender: [{
                validator: Validators.required,
                errorMessage: <Translate id="constants_js.required"/>
            }],
            dateOfBirth: [
                {
                    validator: Validators.date,
                    errorMessage: <Translate id="constants_js.date"/>
                },
                {
                    validator: Validators.date18Plus,
                    errorMessage: <Translate id="constants_js.date18Plus"/>
                },
                {
                    validator: Validators.ageLessThanAgeCap,
                    errorMessage: <Translate id="constants_js.ageLessThanAgeCap"/>
                },
                {
                    validator: () => {
                        return (!this.props.adultYearOfBirthTried || !this.props.adultMonthOfBirthTried || !this.props.adultDayOfBirthTried) ? false : true;
                    },
                    errorMessage: <Translate id="constants_js.date"/>
                }
            ],
            address: [{
                validator: Validators.required,
                errorMessage: <Translate id="constants_js.required"/>
            }],
            city: [{
                validator: Validators.required,
                errorMessage: <Translate id="constants_js.required"/>
            }],
            provinceState: [{
                validator: Validators.required,
                errorMessage: <Translate id="constants_js.required"/>
            }],
            country: [{
                validator: Validators.required,
                errorMessage: <Translate id="constants_js.required"/>
            }],
            postalZipCode: [{
                validator: (s: string) => {
                    return Validators.required(s) || this.props.country === 'Costa Rica';
                },
                errorMessage: <Translate id="constants_js.required"/>
            }],
            signForChildren: [{
                validator: Validators.required,
                errorMessage: <Translate id="constants_js.required"/>
            }],
        };

        API.getRegions()
            .then((countryList) => {
                this.setState({
                    countryList: countryList
                });
            })
            .catch((error) => {
                console.error(error);
            });
    }

    validate() {
        // console.log(this.props.dateOfBirth);
        const validatorKeys = Object.keys(this.validators);
        for (let i = 0; i < validatorKeys.length; i++) {
            const prop = validatorKeys[i];
            const validators = this.validators[prop];
            for (let j = 0; j < validators.length; j++) {
                const validatorPackage = validators[j];
                if (validatorPackage.validator(this.props[prop]) === false) {
                    console.log("Failed for: ", prop);
                    return false;
                }
            }
        }
        return true;
    }

    onFirstNameChange = (e: SyntheticEvent<HTMLInputElement>) => {
        this.props.updateFirstName(e.currentTarget.value);
    }

    onLastNameChange = (e: SyntheticEvent<HTMLInputElement>) => {
        this.props.updateLastName(e.currentTarget.value);
    }

    onPreferredNameChange = (e: SyntheticEvent<HTMLInputElement>) => {
        this.props.updatePreferredName(e.currentTarget.value);
    }

    onEmailChange = (e: SyntheticEvent<HTMLInputElement>) => {
        this.props.updateEmail(e.currentTarget.value);
    }

    onPhoneChange = (phone) => {
        this.props.updatePhone(phone);
    }

    onGenderChange = (value: string) => {
        this.props.updateGender(value);
    }

    onBirthDateChange(year, month, date) {
        if (this.props.dateOfBirth === undefined) {
            this.props.updateDateOfBirth(moment());
        }
        if (!isNaN(year)) {
            this.props.dateOfBirth.year(year);
        }
        if (!isNaN(month)) {
            this.props.dateOfBirth.month(month);
        }
        if (!isNaN(date)) {
            this.props.dateOfBirth.date(date);
        }
    }

    isBirthdayFinished() {
        return isValidDate(this.props.dateOfBirth);
    }

    isBirthdayOldEnough() {
        return this.props.dateOfBirth !== undefined && Validators.date18Plus(this.props.dateOfBirth);
    }

    onAddressChange = (e: SyntheticEvent<HTMLInputElement>) => {
        this.props.updateAddress(e.currentTarget.value);
    }

    onCityChange = (e: SyntheticEvent<HTMLInputElement>) => {
        this.props.updateCity(e.currentTarget.value);
    }

    onProvinceStateChange = (e: SyntheticEvent<HTMLInputElement>) => {
        this.props.updateProvinceState(e.currentTarget.value);
    }

    onCityChangeDrop = (value: string) => {
        this.props.updateCity(value);
    }

    onProvinceStateChangeDrop = (value: string) => {
        this.props.updateProvinceState(value);
    }

    onCountryChange = (value: string, isReal: boolean) => {
        this.props.updateCountry(value);
        if (isReal || isReal === undefined)
            this.setState({countrySet: true});
    }

    onPostalZipChange = (e: SyntheticEvent<HTMLInputElement>) => {
        this.props.updatePostalZipCode(e.currentTarget.value);
    }

    onForChildrenChange = (value: string) => {
        this.props.updateSignForChildren(value);
    }

    onPhoneCountryChange = (e: string) => {
        if (!this.state.countrySet && e !== undefined && Object.keys(this.state.countryList).includes(e)) {
            // console.log("onPhoneCountryChange: " + e);
            this.onCountryChange(e, false);
        } else {
            // console.log("onPhoneCountryChange ignored, already set");
        }
    }

    onClickBack = () => {
        this.props.handleClickBack();
    }

    onClickNext = () => {
        if (this.validate()) {
            this.props.handleClickNext();
        } else {
            toast.error(<Translate id="online_waiver_js.required_generic"/>, {
                autoClose: 8000,
                position:  toast.POSITION.BOTTOM_CENTER
             });
            this.setState({ deferErrors: false });
        }
    }

    getProvinceSelectionMarkup() {
        if (!this.state.countryList[this.props.country]) return <div></div>;
        const isNA = (this.props.country === 'Canada' || this.props.country === 'United States of America');
        if (isNA && this.props.provinceState) {
            return (
                <div>
                    <DropdownSearch
                        label={'Province / State'}
                        options={Object.keys(this.state.countryList[this.props.country])}
                        selectedValue={this.props.provinceState}
                        handleOnChange={this.onProvinceStateChangeDrop}
                        required={true}
                        validators={this.validators.provinceState}
                        deferErrors={this.state.deferErrors}
                        placeholder={'Select an option'}
                    />
                    <DropdownSearch
                        label={'City'}
                        options={this.state.countryList[this.props.country][this.props.provinceState] || []}
                        selectedValue={this.props.city}
                        handleOnChange={this.onCityChangeDrop}
                        required={true}
                        validators={this.validators.city}
                        deferErrors={this.state.deferErrors}
                        placeholder={'Select a city'}
                    />
                </div>
            );
        }
        else if (isNA) {
            return (
                <DropdownSearch
                    label={'Province / State'}
                    options={Object.keys(this.state.countryList[this.props.country])}
                    selectedValue={this.props.provinceState}
                    handleOnChange={this.onProvinceStateChangeDrop}
                    required={true}
                    validators={this.validators.provinceState}
                    deferErrors={this.state.deferErrors}
                    placeholder={'Select an option'}
                />
            );
        }
        else if (this.props.country) {
            return (
                <div>
                    <TextField
                        label={'Province / State'}
                        value={this.props.provinceState}
                        handleOnChange={this.onProvinceStateChange}
                        required={true}
                        validators={this.validators.provinceState}
                        deferErrors={this.state.deferErrors}
                    />
                    <TextField
                        label={'City'}
                        value={this.props.city}
                        handleOnChange={this.onCityChange}
                        required={true}
                        validators={this.validators.city}
                        deferErrors={this.state.deferErrors}
                    />
                </div>
            );
        }
        return null;
    }

    render() {
        const fullBirthday = (this.props.adultYearOfBirthTried && this.props.adultMonthOfBirthTried && this.props.adultDayOfBirthTried);

        const birthdayFinished = this.isBirthdayFinished();
        const birthdayOldEnough = this.isBirthdayOldEnough() || !this.props.adultYearOfBirthTried;

        const birthdayClasses = classNames('BirthdayFields', this.props.className || '', (!this.props.adultYearOfBirthTried && this.state.deferErrors === true) ? '' :
        (!birthdayOldEnough) ? {
            'BirthdayFields--error-under18': true,
            'BirthdayFields--error': true
        } :
        (!birthdayFinished || !fullBirthday) ? {
            'BirthdayFields--error-unfinished': true,
            'BirthdayFields--error': true
        } : '');
        return (
            <div className={'AdultInformation'}>
                <Header
                    header={<Translate id="adult_information_js.render.header"/>}
                    subHeader={<Translate id="adult_information_js.render.sub_header"/>}
                    additionalNotes={<Translate id="adult_information_js.render.additional_notes"/>}
                />
                <TextField
                    label={<Translate id="adult_information_js.render.label_first_name"/>}
                    value={this.props.firstName}
                    handleOnChange={this.onFirstNameChange}
                    required={true}
                    validators={this.validators.firstName}
                    deferErrors={this.state.deferErrors}
                    placeholder={"adult_information_js.render.first_name_placeholder"}
                    placeholderIsTranslation={true}
                    partialAllowedRegex={/^[a-z ,.'-]+$/i}

                />
                <TextField
                    label={<Translate id="adult_information_js.render.label_last_name"/>}
                    value={this.props.lastName}
                    handleOnChange={this.onLastNameChange}
                    required={true}
                    validators={this.validators.lastName}
                    deferErrors={this.state.deferErrors}
                    placeholder={"adult_information_js.render.last_name_placeholder"}
                    placeholderIsTranslation={true}
                    partialAllowedRegex={/^[a-z ,.'-]+$/i}
                />

                <TextField
                    label={<Translate id="adult_information_js.render.label_preferred_name"/>}
                    value={this.props.preferredName}
                    handleOnChange={this.onPreferredNameChange}
                    required={false}
                    //validators={[]}
                    deferErrors={this.state.deferErrors}
                    placeholder={'adult_information_js.render.preferred_name_placeholder'}
                    placeholderIsTranslation={true}
                    partialAllowedRegex={/^[a-z ,.'-]+$/i}
                />
                <TextField
                    label={<Translate id="adult_information_js.render.label_email"/>}
                    value={this.props.email}
                    handleOnChange={this.onEmailChange}
                    required={true}
                    validators={this.validators.email}
                    deferErrors={this.state.deferErrors}
                    placeholder={'adult_information_js.render.email_name_placeholder'}
                    placeholderIsTranslation={true}
                    guide={false}
                    showMask={false}
                    partialAllowedRegex={/^\w+([.-]?|([.-]?\w+)*)(\+|\w)*(\b@?(\b\w+(([.-]?(\w+)*((\b(?!\.\.)\.?(\b\w{1,14})?$)+)?)?)?)?)?$/}
                />
                <Translate>
                { ({translate, activeLanguage, languages}) =>
                  <PhoneField
                    label={translate("adult_information_js.render.label_phone")}
                    placeholder={translate("adult_information_js.render.label_phone")}
                    deferErrors={this.state.deferErrors}
                    required={true}
                    value={ this.props.phone }
                    validators={ this.validators.phone }
                    handleOnChange={ phone => this.onPhoneChange(phone) }
                    defaultCountry={defaultCountry(this.props.country)}
                    handleOnCountryChange={ this.onPhoneCountryChange }
                    // labels={(activeLanguage) ? activeLanguage.code : activeLanguage}
                    />
                }
                </Translate>
                <RadioGroup
                    label={<Translate id="adult_information_js.render.label_gender"/>}
                    selectedValue={this.props.gender}
                    handleChange={this.onGenderChange}
                    optionLabels={[<Translate id="adult_information_js.render.gender_option_labels.male"/>, <Translate id="adult_information_js.render.gender_option_labels.female"/>, <Translate id="adult_information_js.render.gender_option_labels.other"/>]}
                    optionValues={['Male', 'Female', 'Other']}
                    required={true}
                    validators={this.validators.gender}
                    deferErrors={this.state.deferErrors}
                />
                <div className={birthdayClasses}>
                    <div className={'TextField-label'}>
                        {<Translate id="adult_information_js.render.birthday.title"/>}
                        {<span className={'TextField-required'}>{' *'}</span>}
                        {
                            (
                                (
                                    this.props.adultYearOfBirthTried
                                    && !this.isBirthdayOldEnough()
                                    && (
                                        <div className={'TextField-error'}>{<Translate id="adult_information_js.render.birthday.error"/>}</div>
                                    )
                                )
                            )
                        }
                    </div>

                    <Translate>
                    { ({translate}) =>
                    <YearPicker
                        defaultValue={translate("adult_information_js.render.birthday.year")}
                        reverse
                        required={true}
                        value={(this.props.adultYearOfBirthTried) ? this.props.dateOfBirth.year() : 'Select Year'}
                        onChange={(yearOfBirth) => {
                            this.props.updateYearOfBirthTried(true);
                            this.onBirthDateChange(yearOfBirth, this.props.dateOfBirth.month(), this.props.dateOfBirth.date());

                        }}
                        id={'yearOfBirth'}
                        name={'yearOfBirth-dropdown'}
                        aria-label={'Select Year of Birth'}
                        classes={
                            classNames('date-dropdown yearOfBirth-dropdown ',
                            ( this.props.dateOfBirth.year() > moment().year() - 18  && this.props.adultYearOfBirthTried) ?
                            'birthdayValueMissing' : ''
                            )

                        }
                        optionClasses={'option classes'}
                    />
                    }
                    </Translate>
                    <Translate>
                    { ({translate}) =>
                    <MonthPicker
                        defaultValue={translate("adult_information_js.render.birthday.month")}
                        endYearGiven
                        year={this.props.dateOfBirth.year()}
                        required={true}
                        disabled={this.props.dateOfBirth.year() > moment().year() - 18}
                        value={(this.props.adultMonthOfBirthTried) ? this.props.dateOfBirth.month() : 'Select Month'}
                        onChange={(monthOfBirth) => {
                            this.props.updateMonthOfBirthTried(true);
                            this.onBirthDateChange(this.props.dateOfBirth.year(), monthOfBirth, this.props.dateOfBirth.date());
                        }}
                        id={'monthOfBirth'}
                        name={'monthOfBirth'}
                        aria-label={'Select Mpnth of Birth'}
                        classes={
                            classNames('date-dropdown monthOfBirth-dropdown',
                            (
                                (
                                    this.props.dateOfBirth.year() < moment().year() - 18
                                    && !this.props.adultMonthOfBirthTried
                                    && this.state.deferErrors === false
                                ) ? 'birthdayValueMissing' : '')
                            )
                        }
                        optionClasses={'option classes'}
                    />
                    }
                    </Translate>
                    <Translate>
                    { ({translate}) =>
                    <DayPicker
                        defaultValue={translate("adult_information_js.render.birthday.day")}
                        year={this.props.dateOfBirth.year()}
                        month={this.props.dateOfBirth.month()}
                        endYearGiven
                        required={true}
                        disabled={
                            this.props.dateOfBirth === undefined || this.props.dateOfBirth.year() > moment().year() - 18
                        }
                        value={(this.props.adultDayOfBirthTried) ? this.props.dateOfBirth.date() : 'Select Day'}
                        onChange={(dayOfBirth) => {
                            this.props.updateDayOfBirthTried(true);
                            this.onBirthDateChange(this.props.dateOfBirth.year(), this.props.dateOfBirth.month(), dayOfBirth);
                        }}
                        id={'dayOfBirth'}
                        name={'dayOfBirth'}
                        aria-label={'Select Day of Birth'}
                        classes={
                            classNames('date-dropdown dayOfBirth-dropdown',
                            (
                                (
                                    this.props.dateOfBirth.year() < moment().year() - 18
                                    && !this.props.adultDayOfBirthTried
                                    && this.state.deferErrors === false
                                ) ? 'birthdayValueMissing' : '')
                            )
                        }
                        optionClasses={'option classes'}
                    />
                    }
                </Translate>
                </div>

                <DropdownSearch
                    label={<Translate id="adult_information_js.render.label_country"/>}
                    options={Object.keys(this.state.countryList)}
                    selectedValue={this.props.country}
                    handleOnChange={this.onCountryChange}
                    required={true}
                    validators={this.validators.country}
                    deferErrors={this.state.deferErrors}
                    placeholder={<Translate id="adult_information_js.render.country_placeholder"/>}
                />
                {this.getProvinceSelectionMarkup()}
                <TextField
                    label={<Translate id="adult_information_js.render.label_address"/>}
                    value={this.props.address}
                    handleOnChange={this.onAddressChange}
                    required={true}
                    validators={this.validators.address}
                    deferErrors={this.state.deferErrors}
                    placeholder={"adult_information_js.render.address_placeholder"}
                    placeholderIsTranslation={true}
                />
                <TextField
                    label={<Translate id="adult_information_js.render.label_postal_zip"/>}
                    value={this.props.postalZipCode}
                    handleOnChange={this.onPostalZipChange}
                    required={(this.props.country === 'Costa Rica') ? false : true}
                    validators={this.validators.postalZipCode}
                    deferErrors={this.state.deferErrors}
                    placeholder={(this.props.country === 'Costa Rica') ? '' : "adult_information_js.render.postal_zip_placeholder"}
                    placeholderIsTranslation={(this.props.country === 'Costa Rica') ? false : true}
                />
                <RadioGroup
                    label={<Translate id="adult_information_js.render.label_waiver_for"/>}
                    selectedValue={this.props.signForChildren}
                    handleChange={this.onForChildrenChange}
                    optionLabels={[<Translate id="adult_information_js.render.options_waiver_for_myself"/>, <Translate id="adult_information_js.render.options_waiver_for_kids"/>]}
                    optionValues={['Myself', 'Myself and children']}
                    required={true}
                    validators={this.validators.signForChildren}
                    deferErrors={this.state.deferErrors}
                />
                <Footer
                    nextEnabled={this.state.deferErrors === true || this.validate()}
                    handleClickBack={this.onClickBack}
                    handleClickNext={this.onClickNext}
                    nextText={<Translate id="footer_js.next"/>}
                    backText={<Translate id="footer_js.back"/>}
                />
            </div>
        );
    }
}

export default withLocalize(AdultInformation);

// export default AdultInformation;
